/*--------------------------------------------------------------------------------------------------------------------------
IF ANY CHANGES MADE IN HEADER FILE THEN THESE CHANGES MUST BE ADDED IN IMAGEEXTRACTOR HEADER FILE
--------------------------------------------------------------------------------------------------------------------------*/
import React, { useContext, useState } from "react";
import { Layout, Menu, Image, Button, Drawer, message, Avatar, Badge, Tooltip } from "antd";
import { MenuFoldOutlined, MenuUnfoldOutlined, CloseCircleOutlined, ShoppingCartOutlined, UserOutlined, HeartOutlined } from "@ant-design/icons";
import constants from "../../constants/Constants";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { frontendurls } from "../../constants/FrontendURLs";
import logo from "../../logo.svg";
import { COOKIE, cookiesToDelete, deleteCookie, getCookie } from "../../services/Cookie";
import { fetchApi } from "../../services/Api";
import { UserContext } from "./Context";
const { Header } = Layout;

const Headers = () => {
  let location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const name = getCookie(COOKIE.FullName);
  const userID = getCookie(COOKIE.UserId);
  const userType = getCookie(COOKIE.UserType);
  const context = useContext(UserContext);
  const state = {
    userId: userID,
    fromPage: "header",
    userName: name
  };
  const pendingProps = {
    userId: userID,
    fromPage: "header",
    userName: name,
    status:"0",
  };

  const showDrawer = () => { setOpen(true); };
  const onClose = () => { setOpen(false); };
  const logOut = () => {
    const userId = getCookie(COOKIE.UserId);
    const userType = getCookie(COOKIE.UserType);
    let payload = {
      user_type: userType,
      is_logged_in: 0,
    };
    fetchApi(`/logout/${userId}`, "POST", payload)
      .then((res) => {
        if (res?.code === 200) {
          let userTypeId = userType;
          cookiesToDelete.forEach((record) => deleteCookie(record, "/"));
          sessionStorage.clear();
          localStorage.clear();
          if (userTypeId === "1") {
            navigate(frontendurls.AdminLogin);
          } else {
            navigate(frontendurls.UserLogin);
          }
          return;
        }
        message.error(res.message);
      })
      .catch(() => {
        message.error(constants.SomethingWentWrong);
      });
  };

  const menuItems = [
    {
      key: userType&&userType === "1" ? frontendurls.AdminDashboard : frontendurls.Home,
      label: <Link to={userType&&userType === "1" ? frontendurls.AdminDashboard : frontendurls.Home}>{constants.Home}</Link>
    },
    {
      key: userType === "1" ? frontendurls.ListImages : frontendurls.ViewImages,
      label: <Link to={userType&&userType === "1" ? frontendurls.ListImages : frontendurls.ViewImages}>{constants.ListImage}</Link>
    },
    ...(userID ? [
      userType&&userType === "1" && {
        key: "request-menu",
        label: "Requests",
        icon: "",
        children: [
          {
            key: frontendurls.PendingRequests,
            label: <Link to={frontendurls.PendingRequests} state={pendingProps}>{constants.Pending}</Link>
          },
          {
            key: frontendurls.UserRequests,
            label:<Link to={frontendurls.UserRequests}>{constants.UserBased}</Link>,
          },
          {
            key: frontendurls.ImageRequests,
            label:<Link to={frontendurls.ImageRequests}>{constants.ImageBased}</Link>,
          }
        ]
      },
      userType && userType === "1" && {
        key: "imageExtractor",
        label: "Image Extractor",
        onClick: () => {
          window.location.href = `${process.env.REACT_APP_EXTRACTOR_URL}/`;
        },
      },
      userType&&userType === "1" && {
        key: "users-menu",
        label: "Users",
        icon: "",
        children: [
          {
            key: frontendurls.UserListing,
            label: <Link to={frontendurls.UserListing}>{constants.Website}</Link>
          },
          {
            key: frontendurls.AdminListing,
            label:<Link to={frontendurls.AdminListing}>{constants.Admin}</Link>,
          }
        ]
      },
      userType&&userType === "1" && {
        key: frontendurls.ListBooks,
        label: <Link to={frontendurls.ListBooks}>{constants.Books}</Link>
      },
      userType&&userType === "0" && {
        key: frontendurls.MyRequests,
        label: <Link to={frontendurls.MyRequests} state={state}>{constants.MyRequests}</Link>
      },
      userType && userType === "0" && {
        key: frontendurls.ViewCollections,
        label: (
          <Tooltip title={constants.MyCollections}>
            <Link to={frontendurls.ViewCollections}>
              <Badge color="#98002E" showZero={false} count={context?.cartCount}>
                <ShoppingCartOutlined className={`!text-2xl custom-cart-icon-size ${location.pathname === frontendurls.ViewCollections ? 'text-[#EB8A14]' : ' text-gray-600'}`} />
              </Badge>
            </Link>
          </Tooltip>
        ),
        className: '!ps-1 !pe-3 custom-li',
      },
      userType && userType === "0" && {
        key: frontendurls.ViewWishlist,
        label: (
          <Tooltip title={constants.MyWishlist}>
            <Link to={frontendurls.ViewWishlist}>
              <HeartOutlined className={`!text-xl custom-icon-size ${location.pathname === frontendurls.ViewWishlist ? 'text-[#EB8A14]' : ' text-gray-600'}`} />
            </Link>
          </Tooltip>
        ),
        className: '!ps-3 !pe-2 custom-li',
      },
      {
        key: "profile-menu",
        label: name,
        icon: <Avatar size="small" icon={<UserOutlined />} className="bg-primary-light !text-white" />,
        children: [
          {
            key: frontendurls.Profile,
            label: <Link to={frontendurls.Profile}>{constants.MyProfile}</Link>
          },
          {
            key: "logout-action",
            label: constants.LogOut,
            onClick: logOut
          }
        ]
      }
    ] : [
        {
          key: frontendurls.UserLogin,
          label: <Link to={frontendurls.UserLogin}>{constants.Login}</Link>
        },
        {
          key: frontendurls.Register,
          label: <Button
            type="primary"
            onClick={() => navigate(frontendurls.Register)}
          >
            {constants.SignUp}
          </Button>
        }
    ])
  ].filter(Boolean);

  const navigateToHome = () => {
    navigate(userType&&userType === "1" ? frontendurls.AdminDashboard : frontendurls.Home);
  };

  return (
    <Header className='imagebank-header z-50 flex justify-between items-center !px-3 lg:!px-10 pt-2 border-b sticky top-0 w-full h-auto' id='top'>
      <Image className="cursor-pointer" onClick={navigateToHome} src={logo} alt="Plural Publishing Image Bank" preview={false} width={120} />
      <Button
        type="primary"
        size="large"
        className="flex flex-center lg:!hidden"
        icon={open ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />}
        onClick={showDrawer}
      />
      <Menu
        mode="horizontal"
        className="bg-transparent hidden lg:block border-b-0"
        disabledOverflow
        selectedKeys={[location.pathname]}
        items={menuItems}
      />
      <Drawer
        title={<span className='text-white'>{constants.ImageBank}</span>}
        placement="right"
        width={250}
        styles={{
          header: { background: '#6B0121' },
          body: { padding: 0, background: '#6B0121' }
        }}
        onClose={onClose}
        open={open}
        closeIcon={<CloseCircleOutlined className='text-white' />}
      >
        <Menu
          mode="inline"
          theme="dark"
          className='custom-menu text-white'
          disabledOverflow
          selectedKeys={[location.pathname]}
          items={menuItems}
        />
      </Drawer>
    </Header>
  );
};
export default Headers;
